import { useState } from "react";
import { motion } from "framer-motion";
import { ArrowRight, Sparkles } from "lucide-react";
import DashboardModal from "@/components/DashboardModal";

const Hero = () => {
  const [isDashboardOpen, setIsDashboardOpen] = useState(false);

  const scrollToContact = () => {
    const element = document.getElementById("contact");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center pt-20" data-testid="hero-section">
      <div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: `url('https://images.unsplash.com/photo-1762279388988-3f8abcc7dca2?crop=entropy&cs=srgb&fm=jpg&q=85')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-black/80" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center"
        >
          <h1
            className="font-heading font-black text-5xl sm:text-6xl lg:text-8xl tracking-tight leading-none mb-6 gradient-text"
            data-testid="hero-title"
          >
            Align What Matters.<br />Illuminate What's Next.
          </h1>

          <p
            className="font-body text-lg md:text-xl text-slate-400 leading-relaxed max-w-2xl mx-auto mb-12"
            data-testid="hero-subtitle"
          >
            LucentisIQ is the intelligence layer for enterprise transformation — aligning what matters and revealing risk before it impacts results.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-testid="hero-cta-group">
            <button
              onClick={scrollToContact}
              className="group px-8 py-4 rounded-full bg-gradient-to-r from-pink-500 to-lime-500 text-black font-bold hover:shadow-[0_0_30px_rgba(236,72,153,0.6)] transition-all duration-300 flex items-center gap-2"
              data-testid="hero-primary-cta"
            >
              Request an Executive Brief
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </button>
            <button
              onClick={() => setIsDashboardOpen(true)}
              className="px-8 py-4 rounded-full border border-white/20 hover:bg-white/10 text-white transition-all duration-300"
              data-testid="hero-secondary-cta"
            >
              Explore the Platform
            </button>
          </div>
        </motion.div>
      </div>
      <DashboardModal isOpen={isDashboardOpen} onClose={() => setIsDashboardOpen(false)} />
    </section>
  );
};

export default Hero;
